import { SuccessReturnBody, getSuccessReturnBody } from '../../general';
import { ConstantKeysWidgets } from 'types/noocoEnums';

export interface Widgets {
  key: ConstantKeysWidgets;
  data?: unknown;
};

export interface PostPdfPayload {
  widgets: Widgets[];
}

export interface PostPDFData {
  id: string,
  status: string,
  updatedAt: string,
  downloadUrl: string | null,
  previewUrl: string,
  publicShareLink: string | null,
}

export function postPDFReturnBody(body: PostPDFData): SuccessReturnBody {
  return getSuccessReturnBody(body)
}
